import React, { useState } from "react";
import { ImprovedProduct } from "../../Interfaces/Product";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ImprovedParticipantShop } from "../../Interfaces/FundraiserRole";
import { generateUniqueId } from "../../Interfaces/Types";
import { logoOverlayFetcher } from "../../pages/ImprovedShopPage/SingleProductPageHelpers";
import { Category } from "../../../src/CommonFunctions";
import "./ProductCard.css";
import AddToCartButton from "../Storefront/AddToCartButton";

interface ProductCardProps {
  product: ImprovedProduct;
  participantID: string;
  shopInfo: ImprovedParticipantShop;
  isFromSamplePage?: boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({
  product,
  participantID,
  shopInfo,
  isFromSamplePage = false,
}) => {
  const navigate = useNavigate();

  const [isHovered, setIsHovered] = useState(false);

  const baseImage =
    product.images?.find((img: string) => img.includes("base_")) ||
    product.images?.[0] ||
    "";
  const logoImage =
    product.images?.find(
      (img: string) => !img.includes("base_") && img !== baseImage,
    ) || baseImage;

  const getCategory = (): Category => {
    if (!shopInfo.sku_by_category) return Category.Default;

    for (const [category, skus] of Object.entries(shopInfo.sku_by_category)) {
      if (Array.isArray(skus) && skus.includes(Number(product.sku))) {
        return category as Category;
      }
    }
    return Category.Default;
  };

  const category = getCategory();
  const overlayStyle = logoOverlayFetcher(category, false);

  const handleNavigateToProduct = () => {
    navigate(`/refactored-product/${product.sku}`, {
      state: {
        shopInfo: shopInfo,
        participantID,
      },
    });
  };

  return (
    <div
      className="product-card bg-white rounded shadow-sm"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="product-card__image-container">
        <img
          src={baseImage}
          alt={product.name}
          className="product-card__image"
          style={{ opacity: isHovered ? 0.9 : 1 }}
        />
        {isHovered && logoImage && logoImage !== baseImage && (
          <img
            src={logoImage}
            alt="Customization Preview"
            style={{
              position: "absolute",
              width: overlayStyle?.width || "60%",
              height: "auto",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              ...overlayStyle,
              pointerEvents: "none",
              opacity: 0.9,
            }}
          />
        )}
      </div>
      <div className="product-card__content">
        <p className="product-card__title">{product.name}</p>
        <p className="product-card__price">${product.base_price}</p>
        {product.is_customizable ? (
          <Button
            variant="contained"
            fullWidth
            onClick={(e) => {
              e.stopPropagation();
              handleNavigateToProduct();
            }}
            style={{ marginTop: "auto" }}
          >
            Customize Now
          </Button>
        ) : (
          <AddToCartButton
            item={{
              id: generateUniqueId(),
              sku: product.sku,
              name: product.name,
              image: product.images[0],
              price: product.base_price,
              quantity: 1,
              customization: {},
            }}
            participant={shopInfo.participant}
            isFromSamplePage={isFromSamplePage}
          />
        )}
      </div>
    </div>
  );
};

export default ProductCard;
